import { StatisticDetailItem } from 'src/models/pages/profession';
import { getCurrencyThousandthsRange } from 'src/utils/currency';

import { BAR_GAP, BAR_MIN_WIDTH } from 'src/pages/Profession/components/SectionStatistics/DetailChart/Chart/constants';

export const getMinWidth = (barCount: number): number => {
    const width = barCount * (BAR_MIN_WIDTH + BAR_GAP);
    const leftRightWithoutGab = BAR_GAP;
    return width - leftRightWithoutGab;
};

export const tickFormatter = (value: StatisticDetailItem['salaryStr']): string => {
    const [from, to] = value.split(',').map((str) => +str);
    if (!from && !to) {
        return '';
    }
    return getCurrencyThousandthsRange(from, to);
};
